import {
  Card,
  CardContent,
  Chip,
  Col,
  Flex,
  Heading,
  Icon,
  Icons,
  Paragraph,
  Row,
} from "@ir/ui";

export interface OrganizationDetailsStatsProps {
  organizationName: string;
  organizationKey: string;
  brandCount: number;
}

export const OrganizationDetailsStats = ({
  organizationName,
  organizationKey,
  brandCount,
}: OrganizationDetailsStatsProps) => {
  return (
    <Row className="mb-4">
      <Col span={4}>
        <Card className="bg-white" variant="outlined" shadow>
          <CardContent>
            <Paragraph className="text-grey-500 font-regular m-0">
              Name
            </Paragraph>
            <Heading level={4} className="text-primary font-bold m-0">
              {organizationName || "-"}
            </Heading>
          </CardContent>
        </Card>
      </Col>
      <Col span={4}>
        <Card className="bg-white" variant="outlined" shadow>
          <CardContent>
            <Flex align="center" justifyContent="space-between">
              <Paragraph className="text-grey-500 font-regular m-0">
                Key
              </Paragraph>
              <Chip
                onClick={() => {
                  navigator.clipboard.writeText(organizationKey);
                }}
                htmlTitle="Copy Key"
                size="medium"
                color="grey"
                borderless
                shape="square"
                icon={<Icon size="small" name={Icons.Copy} />}
              />
            </Flex>

            <Heading level={4} className="text-primary font-bold m-0">
              {organizationKey || "-"}
            </Heading>
          </CardContent>
        </Card>
      </Col>
      <Col span={4}>
        <Card className="bg-white" variant="outlined" shadow>
          <CardContent>
            <Paragraph className="text-grey-500 font-regular m-0">
              Brands
            </Paragraph>
            <Heading level={4} className="text-primary font-bold m-0">
              {brandCount}
            </Heading>
          </CardContent>
        </Card>
      </Col>
    </Row>
  );
};
